export const babyPushServiceWorkerPath = "/baby-push-sw.js";

export const browserSupportsBabyPush = () => (
  "serviceWorker" in navigator &&
  "PushManager" in window &&
  "Notification" in window
);

export const registerBabyPushServiceWorker = async () => {
  if (!browserSupportsBabyPush()) {
    throw new Error("This browser does not support web push notifications.");
  }

  return navigator.serviceWorker.register(babyPushServiceWorkerPath);
};

export const urlBase64ToUint8Array = (base64String) => {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = `${base64String}${padding}`.replace(/-/g, "+").replace(/_/g, "/");
  const rawData = window.atob(base64);
  return Uint8Array.from([...rawData].map((character) => character.charCodeAt(0)));
};

export const subscribeToBabyPush = async (publicKey) => {
  const registration = await registerBabyPushServiceWorker();
  const existingSubscription = await registration.pushManager.getSubscription();
  if (existingSubscription) {
    return existingSubscription;
  }

  return registration.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(publicKey),
  });
};
